export { UserSettingsEffectDependencies } from './dependency';
import { loadUserSettingsEffect } from './load-user-settings.effect';

export const effects = [loadUserSettingsEffect];
